import app from './app.js';

export default {
	...app,
	components: [{ title: 'ai_model', component: 'ai_model', test_user: true }, ...app.components],
};
